var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "divider-edit"
  }, [_c('style-bar', {
    staticClass: "mb-2",
    attrs: {
      "css-keys": ['background', 'color', 'textAlign'],
      "mode": "text",
      "styles": _vm.localStyles
    },
    on: {
      "update:styles": function updateStyles($event) {
        _vm.localStyles = $event;
      }
    }
  }), _c('rich-text-input', {
    staticClass: "py-2 px-4",
    style: _vm.localStyles,
    attrs: {
      "mode": "input",
      "placeholder": _vm.$t('divideredit_section_title_placeholder'),
      "content": _vm.form.content,
      "json": _vm.editorContentJson,
      "label": _vm.$t('divideredit_divider_title')
    },
    on: {
      "update:content": function updateContent($event) {
        return _vm.$set(_vm.form, "content", $event);
      },
      "update:json": function updateJson($event) {
        _vm.editorContentJson = $event;
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }